module.exports = __webpack_public_path__ + "static/media/m6cr168.336e17e0.png";